import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';

//Componentes auxiliares:
import HelpButton from '../layouts/mainLayout/components/HelpButton';
import SourcesManager from '../components/downloadSourcesConfiguration/SourcesManager';

//Contenido del tour de ayuda:
import { downloadSourcesConfigurationTourConfig } from './tours/DownloadSourcesConfiguration';

class DownloadSourcesConfiguration extends React.Component {

    constructor() {
        super();

        this.state = {

        }
    }

    render() {
        return (
            <div className="content">
                <Row>
                    <Col xs="12" md="12" lg="12" xl="12">
                        <SourcesManager />
                    </Col>
                </Row>
            </div>
        );
    }

    componentDidMount() {
        this.props.changeRelatedNavbarButtons([
            <HelpButton tourContent={downloadSourcesConfigurationTourConfig} />
        ]);
    }
}

const mapdispatchToProps = dispatch => {
    return {
        changeRelatedNavbarButtons: (navbarButtons) => dispatch({ type: "changeNavbarButtons", navbarButtons: navbarButtons })
    };
};

const mapStateToProps = state => {
    return {
        activeUser: state.mainReducer.activeUser,
    };
};

export default connect(mapStateToProps, mapdispatchToProps)(DownloadSourcesConfiguration);